<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-btn slot="activator" color="primary" dark>
      Bulk Update Jobs
    </v-btn>
    <v-toolbar color="primary">
      <v-spacer></v-spacer>
      <v-btn icon flat @click="dialog = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-container>
        <v-card-title>
          <span class="headline">Bulk Update Jobs</span>
        </v-card-title>
        <v-card-text>
          <h3>Please paste data to be imported below, column order must match the export from the jobs page.</h3>
          <v-container>
              <v-textarea v-model="excelInput" label="Excel Data Input"></v-textarea>
              <v-layout row wrap>
                <v-select label="Columns to import" :items="availableColumns" v-model="selectedColumns" multiple chips deletable-chips return-object></v-select>
              </v-layout>
              <v-layout row>
                <v-checkbox v-model="includeHeaders" label="Input includes header row"></v-checkbox>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="processRawData" :disabled="!excelInput" :loading="processing">Process Data</v-btn>
              </v-layout>
              <div v-if="dataProcessed" class="mt-5">
                <span class="title">Output Data</span>
                <p>Green cells will be updated</p>
                <v-data-table hide-actions :items="processedData" :headers="availableColumns">
                  <template slot="items" slot-scope="props">
                    <tr><td :class="{'green': selectedColumns.findIndex(a => column.value === a.value) !== -1}" v-for="column in availableColumns">{{props.item[column.value]}}</td></tr>
                  </template>
                </v-data-table>
                <v-layout align-center>
                  <v-spacer></v-spacer>
                  <v-checkbox class="shrink" label="I confirm the above output is correct" v-model="dataLooksGood"></v-checkbox>
                  <v-btn color="primary" @click="updateJobs" :loading="updating" :disabled="!dataLooksGood">Update Job Details</v-btn>
                </v-layout>
              </div>
            </v-container>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { fireStore } from '../../firebase'
export default {
  data () {
    return {
      processedData: [],
      dataProcessed: false,
      dialog: false,
      processing: false,
      excelInput: '',
      updating: false,
      selectedColumns: [
        { text: 'Customer Price', value: 'customerPrice' },
        { text: 'Engineer Cost', value: 'engineerCost' },
        { text: 'Hardware Cost', value: 'hardwareCost' },
        { text: 'Invoiced', value: 'invoiced' }
      ],
      availableColumns: [
        { text: 'UID', value: 'id', disabled: true },
        { text: 'Customer', value: 'customer', disabled: true },
        { text: 'Vehicle', value: 'vehicle', disabled: true },
        { text: 'Created Date', value: 'CreatedDate', disabled: true },
        { text: 'Scehduled Date', value: 'Date', disabled: true },
        { text: 'Completed Date', value: 'CompletedDate', disabled: true },
        { text: 'Supplier', value: 'Supplier', disabled: true },
        { text: 'Engineer', value: 'Engineer', disabled: true },
        { text: 'Project', value: 'Project', disabled: true },
        { text: 'Job Number', value: 'Job Number', disabled: true },
        { text: 'Status', value: 'Status', disabled: true },
        { text: 'Notes', value: 'Notes', disabled: true },
        { text: 'Customer Price', value: 'customerPrice', disabled: false },
        { text: 'Engineer Cost', value: 'engineerCost', disabled: false },
        { text: 'Hardware Cost', value: 'hardwareCost', disabled: false },
        { text: 'Invoiced', value: 'invoiced', disabled: false }
      ],
      dataLooksGood: false,
      includeHeaders: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    }
  },
  methods: {
    processRawData () {
      this.processing = true
      this.processedData = []
      let columnIndexes = []
      for (let column of this.selectedColumns) {
        let index = this.availableColumns.findIndex(a => a.value === column.value)
        columnIndexes.push(index)
      }
      let rows = []
      let excelInput = this.excelInput
      excelInput.replace(/"([^"]*)"/g, 'notes replaced')
      rows = excelInput.split('\n')
      if (this.includeHeaders) {
        rows.splice(0, 1)
      }
      rows.forEach(row => {
        if (row === '') {
          return
        }
        const cols = row.split('\t')
        const obj = {}
        for (let i = 0; i < cols.length; i++) {
          if (cols[i] && cols[i].length > 0) {
            obj[this.availableColumns[i].value] = cols[i]
          }
        }
        this.processedData.push(obj)
      })
      this.dataProcessed = true
      this.processing = false
    },
    updateJobs () {
      this.updating = true
      let batch = fireStore.batch()
      for (let item of this.processedData) {
        let obj = {}
        for (let column of this.selectedColumns) {
          if (item[column.value]) {
            obj[column.value] = item[column.value]
          }
        }
        if (Object.keys(obj).length) {
          const ref = fireStore.collection('Jobs').doc(item.id)
          batch.update(ref, obj)
        }
      }

      batch.commit()
        .then(() => {
          this.$emit('updateComplete')
          this.updating = false
        })
        .catch(error => {
          console.log(error)
          this.updating = false
          alert('Something went wrong :(')
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// BulkUpdateJobsDialog.vue?6d2b3c70